import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    record: {
      '&:not(:last-child)': {
        borderBottom: '1px solid #DBDDE0'
      },
      width: '100%',
      padding: '0 12px',
      fontSize: '14px',
      color: '#707275',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      height: '40px',
      lineHeight: '40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
});